'use strict';

const DRAWER_PADDING_HEIGHT = 27;
const MERCHANT_HOURS_DRAWER_PADDING_HEIGHT = 6;

const getExpectedDrawerHeight = drawer => {
  return Math.ceil(
    [...drawer.children].reduce((sumHeight, el) => {
      if (el.scrollHeight === 0) {
        return sumHeight;
      }
      const elStyles = window.getComputedStyle(el);
      return (
        sumHeight +
        el.scrollHeight +
        parseInt(elStyles.getPropertyValue('margin-top')) +
        parseInt(elStyles.getPropertyValue('margin-bottom'))
      );
    }, 0)
  );
};

const bindToggleDrawer = (el, setDrawerHeightOnLoad = true) => {
  const trigger = el.querySelector('.toggle-header'); // triggered by click on header element
  const drawer = el.querySelector('.toggle-content'); // class must be added to content element

  if (!trigger || !drawer) {
    return;
  }

  let drawerHeight =
    el.classList.contains('open') && setDrawerHeightOnLoad
      ? `${drawer.offsetHeight}px`
      : undefined;

  const closeToggleDrawer = () => {
    drawerHeight = `${drawer.scrollHeight}px`;
    drawer.style.height = `${drawer.scrollHeight}px`;

    requestAnimationFrame(() => {
      el.classList.remove('open');
      drawer.style.height = 0;
    });
  };
  const openToggleDrawer = () => {
    if (!drawerHeight) {
      let paddingHeight;
      if (el.classList.contains('merchant-hours')) {
        paddingHeight = MERCHANT_HOURS_DRAWER_PADDING_HEIGHT;
      } else {
        paddingHeight = DRAWER_PADDING_HEIGHT;
      }
      drawerHeight = `${getExpectedDrawerHeight(drawer) + paddingHeight}px`;
    }
    drawer.style.height = drawerHeight;

    requestAnimationFrame(() => {
      el.classList.add('open');
    });

    if ('ontransitionend' in window) {
      drawer.addEventListener(
        'transitionend',
        () => (drawer.style.height = ''),
        { once: true }
      );
    } else {
      setTimeout(() => (drawer.style.height = ''), 400);
    }
  };

  trigger.addEventListener('click', () =>
    el.classList.contains('open') ? closeToggleDrawer() : openToggleDrawer()
  );
};

const bindToggleDrawers = () => {
  const toggleDrawers = document.querySelectorAll('.toggle-drawer') || []; // class must be added to parent container

  for (const drawer of toggleDrawers) {
    const arrowIcon = drawer.querySelector('.toggle-arrow');

    if (!arrowIcon || window.getComputedStyle(arrowIcon).display !== 'none') {
      bindToggleDrawer(drawer);
    }
  }
};

module.exports = {
  bindToggleDrawer,
  bindToggleDrawers,
  getExpectedDrawerHeight,
  DRAWER_PADDING_HEIGHT,
};
